<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-11-07 15:01:24
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2023-08-01 14:46:43
-->
<template>
	<div class="remarkCell">
		<el-tooltip placement="top" :content="row.specificationRemark" v-ak-tooltip-auto-show>
			<span class="line-ellipsis-2" style="width: 100%;">{{ row.specificationRemark }}</span>
		</el-tooltip>
		<i class="el-icon-edit-outline cursor-pointer hover" @click="openRemark"></i>
		<el-dialog title="备注" :visible.sync="visible" :before-close="beforeClose" width="400px" :append-to-body="true">
			<div class=" flex-row flex-just-start">
				<p class="mr-16 nowarp">备注内容</p>
				<el-input type="textarea" :rows="3" placeholder="请输入" v-model="remark" />
			</div>
			<div slot="footer">
				<el-button @click="visible = false">取 消</el-button>
				<el-button type="primary" @click="confirm">确 认</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import mixin from './mixin';
export default {
	mixins: [mixin],
	inject: ['changeSkuRamerk'],
	data() {
		return {
			visible: false,
			remark: '',
		};
	},
	methods: {
		beforeClose() {
			this.remark = '';
			this.visible = false;
		},
		confirm() {
			this.row.specificationRemark = this.remark;
			this.changeSkuRamerk(this.remark, this.row)
			this.beforeClose();
		},
		openRemark() {
			this.remark = this.row.specificationRemark || ''
			this.visible = true;
		}
	},
};
</script>
<style lang="less" scoped></style>
